import { Divider } from "@msuite/ui/divider";
import { Tag } from "@msuite/ui/tag";
import { getAddressString } from "@msuite/utils/strings";
import type { StaticProject } from "@msuite/utils/types";
import { CommandPlanTicket } from "./command-plan-ticket";

/** Props Interface */
interface CommandPlanProjectProps {
	project: StaticProject;
}

export function CommandPlanProject({ project }: CommandPlanProjectProps) {
	return (
		<div
			className="card v-stack gap-1"
			key={project.id}
		>
			<Tag
				variant="plain"
				color={project.workspace.color || "gray"}
			>
				{project.workspace.name}
			</Tag>
			<Divider variant="card" />
			<div className="h-stack justify-between">
				<p>{project.name}</p>
				<p>{project.number}</p>
			</div>
			<p>{getAddressString(project)}</p>
			<p>{project.clientName}</p>
			{project.tickets.map((ticket) => (
				<CommandPlanTicket
					key={ticket.id}
					ticket={ticket}
				/>
			))}
		</div>
	);
}
